<ng-container *ngIf="loading">
  <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading">
     <div class="mt-4">
        <app-imp-notice [impText]='importantText' [hidden]="showTermsConditions"></app-imp-notice>
    </div>

    <div class="new-card-container"  [hidden]="showTermsConditions">
        <div class="card-type-container">
            <div class="card-select-title">{{ 'Select your card type if you are adding a new card' }}</div>
            <div class="card-radio">
                <input type="radio" class="radio-button" id="credit" name="cardType" 
                    value="CC" [(ngModel)]="selectedTypeCard">
                <label class="no-margin-bottom align-top" for="credit">{{ 'Credit card' }}</label>
            </div> 
            <div class="card-radio">
                <input type="radio" class="" id="debit" name="cardType" 
                    value="DC" [(ngModel)]="selectedTypeCard">
                <label class="no-margin-bottom align-top" for="debit">{{ 'Debit card' }}</label>
            </div>  
        </div>
        <button 
            (click)="addNewCard()"
            class="mapfre btn link-button red-link add-new-card"
            [disabled]="!selectedTypeCard" 
        >
            <span class="plus-icon-box">
                <svg
                    width="18.08"
                    height="18.08"
                    viewBox="0 0 18.08 18.08"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <line x1="9.04" y1="0" x2="9.04" y2="18.08"
                        stroke="currentColor" stroke-width="2"/>
                    <line x1="0" y1="9.04" x2="18.08" y2="9.04"
                        stroke="currentColor" stroke-width="2"/>
                </svg>
            </span>
            {{ "Add new card" | translate }}
        </button>
    </div>        

    <form 
        [hidden]="showTermsConditions"
        [formGroup]="enrollInAutopay" 
        name="enrollInAutopay"  
        (ngSubmit)="enroll(policyId) "
    >

        <div class="add-select-card-space" *ngIf="existingCards?.length > 0">
            <div class="card-select-title">{{ 'Use a saved card' }}</div>
            <div class="card-type-container">
                <div class="card-select-container card-radio" *ngFor="let card of existingCards; index as index;" >
                    <input type="radio" class="radio-button" [id]="'card-' + card.id"
                        [value]="card" [formControlName]="'cardTypeSelect'">
                    <label class="no-margin-bottom align-top" [for]="'card-' + card.id">
                        <div class="icon-card-details-sec">
                            <img src="{{card.icon}}" alt="{card.type}">
                            <div class="card-details-sec">
                                <div>{{ card.typeNum }}</div>
                                <div>{{ card.expires }}</div>
                                <div>{{ card.name | lowercase | titlecase }}</div>
                            </div>
                        </div>                    
                    </label>
                </div> 
            </div>
        </div>

        <hr class="hr-profile mt-4 mb-4"/>

        <div class="row enroll-eft-epay-form mass-check">
            <div class="col">
                <div 
                    class="default-checkbox-label" 
                    [class.inactive]="!isTermsAndCondReview"
                >
                <input 
                    (click)="onCheckboxClick($event)"
                    id="termsAndCond-checkbox"  
                    type="checkbox" 
                    [formControlName]="'termsAndCondCheck'"
                    required
                >
                <label class="ml-3" for="termsAndCond-checkbox">
                    {{ "I confirm that I have read and agree to the" | translate }}
                    <a
                    (click)="onTermsConditionsClick()"
                    class="link-ap-terms-conditions nowrap"
                    >{{ "autopay terms and conditions" | translate }}</a>.           
                </label>
            </div>
                <div class="error-block warning-row warn-terms-conditions-margin">
                    <span class="warning-icon"></span>
                    <span>{{ 'Please review the terms above to enable this checkbox.' | translate }}</span>
            </div>
            </div>
        </div>

        <div class="row margin-top mt24 text-center enroll-eft-epay-form">
            <div class="col">
                <mapfre-button
                    [ngClass]="{'custom_loader':loader}"
                    [additionalClasses]="'basic primary large-btn  mx-auto'"
                    [disabledValue]="enrollInAutopay.valid && !loader" 
                    [inputType]="'submit'"
                    [translateValue]="'ENROLL_LOWERCASE' | translate"
                ></mapfre-button>
            </div>
        </div>
    </form>
</ng-container>
<app-autopay-terms-conditions
  *ngIf="showTermsConditions"
  [type]="'credit/debit card'"
  (showTermsConditions)="onHideTermsConditions($event)"
></app-autopay-terms-conditions>